/* eslint-disable no-plusplus */
/* eslint-disable @typescript-eslint/no-throw-literal */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/no-unused-expressions */
import { LatLng, LatLngLiteral, LatLngTuple, Point } from 'leaflet';
import { isArray } from 'lodash';

import { Coord } from '@turf/helpers';
import { TurfPolygon } from 'src/types/components/map.type';
import pointToLineDistance from '@turf/point-to-line-distance';
import { EWeightUnit } from 'src/enums/mixed.enum';

const R = 6371000;
const pi = Math.PI;
const dayBySecond = 86400;
const hourBySecond = 3600;
const minuteBySecond = 60;

export function getNorth(center: LatLngLiteral, attr: number) {
  return L.latLng(attr, center.lng);
}

export function getSouth(center: LatLngLiteral, attr: number) {
  return L.latLng(attr, center.lng);
}

export function getWest(center: LatLngLiteral, attr: number) {
  return L.latLng(center.lat, attr);
}

export function getEast(center: LatLngLiteral, attr: number) {
  return L.latLng(center.lat, attr);
}

export function pointToArray(point: LatLngLiteral) {
  return [point.lat, point.lng];
}

export function arrayToPoint(point: LatLngTuple) {
  return { lat: point[0], lng: point[1] };
}

export function reverse(point: LatLngTuple | LatLngLiteral): LatLngTuple | LatLngLiteral {
  if (isArray(point)) {
    return [point[1], point[0]];
  }
  return { lng: point.lng, lat: point.lat };
}

// export function polygonSideLengths(polygon: Polygon) {
//   const corners = polygon.getLatLngs()[0];

//   const lengths = [];
//   if (isArray(corners)) {
//     let j = 0;
//     for (let i = 0; i < corners.length; i += 1) {
//       i === corners.length - 1 ? (j = 0) : (j = i + 1);
//       lengths.push(distancePoint(corners[i], corners[j]));
//     }
//   }
//   return lengths;
// }

// export function sortCoordinates(arr, size) {
//   if (arr.length % (size + 1) === 0) {
//     const returnArr: any[] = [];
//     arr.sort(compareByLat);
//     for (let i = 0; i < arr.length; i += size + 1) {
//       const slice = arr.slice(i, i + size + 1);
//       slice.sort(compareByLng);
//       slice.forEach((point) => {
//         returnArr.push(point);
//       });
//     }
//     return returnArr;
//   }
// }

export function comparePoints(point1: LatLngTuple | LatLngLiteral, point2: LatLngTuple | LatLngLiteral) {
  if (isArray(point1) && isArray(point2)) {
    return compareCoordinates(arrayToPoint(point1), arrayToPoint(point2));
  }
  if ((isArray(point1) && !isArray(point2)) || (!isArray(point1) && isArray(point2))) {
    throw 'Points are not compitable.';
  } else if (
    typeof (point1 as LatLngLiteral).lat !== 'undefined' &&
    typeof (point1 as LatLngLiteral).lng !== 'undefined' &&
    typeof (point2 as LatLngLiteral).lat !== 'undefined' &&
    typeof (point2 as LatLngLiteral).lng
  ) {
    return compareCoordinates(point1 as LatLngLiteral, point2 as LatLngLiteral);
  } else {
    throw 'Points are not in expected format';
  }
}

export function compareCoordinates(point1: LatLngLiteral, point2: LatLngLiteral) {
  if (point1.lat + point1.lng < point2.lat + point2.lng) {
    return -1;
  }
  if (point1.lat + point1.lng > point2.lat + point2.lng) {
    return 1;
  }
  if (point1.lat < point2.lat) {
    return -1;
  }
  if (point1.lat > point2.lat) {
    return 1;
  }
  if (point1.lng < point2.lng) {
    return -1;
  }
  if (point1.lng > point2.lng) {
    return 1;
  }
  return 0;
}

export function compareByLat(point1: LatLngTuple | LatLngLiteral, point2: LatLngTuple | LatLngLiteral) {
  if (isArray(point1) && isArray(point2)) {
    return compareLat(arrayToPoint(point1), arrayToPoint(point2));
  }
  if ((isArray(point1) && !isArray(point2)) || (!isArray(point1) && isArray(point2))) {
    throw 'Points are not compitable.';
  } else if (
    typeof (point1 as LatLngLiteral).lat !== 'undefined' &&
    typeof (point1 as LatLngLiteral).lng !== 'undefined' &&
    typeof (point2 as LatLngLiteral).lat !== 'undefined' &&
    typeof (point2 as LatLngLiteral).lng
  ) {
    return compareLat(point1 as LatLngLiteral, point2 as LatLngLiteral);
  } else {
    throw 'Points are not in expected format';
  }
}

export function compareLat(point1: LatLngLiteral, point2: LatLngLiteral) {
  if (point1.lat < point2.lat) return -1;
  if (point1.lat > point2.lat) return 1;
  return 0;
}

export function compareByLng(point1: LatLngTuple | LatLngLiteral, point2: LatLngTuple | LatLngLiteral) {
  if (isArray(point1) && isArray(point2)) {
    return compareLng(arrayToPoint(point1), arrayToPoint(point2));
  }
  if ((isArray(point1) && !isArray(point2)) || (!isArray(point1) && isArray(point2))) {
    throw 'Points are not compitable.';
  } else if (
    typeof (point1 as LatLngLiteral).lat !== 'undefined' &&
    typeof (point1 as LatLngLiteral).lng !== 'undefined' &&
    typeof (point2 as LatLngLiteral).lat !== 'undefined' &&
    typeof (point2 as LatLngLiteral).lng
  ) {
    return compareLng(point1 as LatLngLiteral, point2 as LatLngLiteral);
  } else {
    throw 'Points are not in expected format';
  }
}

export function compareLng(point1: LatLngLiteral, point2: LatLngLiteral) {
  if (point1.lng < point2.lng) return -1;
  if (point1.lng > point2.lng) return 1;
  return 0;
}

export function filterFloats(point: LatLngTuple | LatLngLiteral) {
  if (isArray(point)) {
    return [point[0].toFixed(6), point[1].toFixed(6)];
  }
  return { lat: point.lat.toFixed(6), lng: point.lng.toFixed(6) };
}

export function rotatePoints(map: L.Map, center: L.LatLng, points: L.LatLng[], degree: number): LatLng[] {
  const res: LatLng[] = [];
  const centerPoint = map.latLngToLayerPoint(center);
  const angle = degree * (Math.PI / 180);

  for (let i = 0; i < points.length; i++) {
    const point = map.latLngToLayerPoint(points[i]);
    const distanceToCenter = new Point(point.x - centerPoint.x, point.y - centerPoint.y);
    const rotated = new Point(
      Math.cos(angle) * distanceToCenter.x - Math.sin(angle) * distanceToCenter.y,
      Math.sin(angle) * distanceToCenter.x + Math.cos(angle) * distanceToCenter.y,
    );

    const translateBack: LatLngTuple = [rotated.x + centerPoint.x, rotated.y + centerPoint.y];

    res.push(map.layerPointToLatLng(translateBack));
  }

  return res;
}

export function globalRhombDiagonalLength(length: number) {
  const b = length / R;
  const cosb = Math.cos(b);
  const a = Math.acos(2 * cosb - 1);

  return a * R;
}

export function locationToIdx(sides: TurfPolygon, location: Coord, cellCounts: number) {
  const distanceToWest = pointToLineDistance(location, sides.west);
  const distanceToEast = pointToLineDistance(location, sides.east);

  const x = Math.floor((distanceToWest / (distanceToWest + distanceToEast)) * cellCounts);

  const distanceToSouth = pointToLineDistance(location, sides.south);
  const distanceToNorth = pointToLineDistance(location, sides.north);

  const y = Math.floor((distanceToSouth / (distanceToSouth + distanceToNorth)) * cellCounts);

  return { x, y };
}

export const remainingTimeCalculator = (incomingRemainingTime: number) => {
  const remainingTime = incomingRemainingTime;
  let modRemaining;

  const days = Math.floor(remainingTime / dayBySecond);
  modRemaining = remainingTime % dayBySecond;
  const hours = Math.floor(modRemaining / hourBySecond);
  modRemaining %= hourBySecond;
  const mins = Math.floor(modRemaining / minuteBySecond);
  const secs = modRemaining % minuteBySecond;

  return { days, hours, mins, secs };
};

export const latLongToDmsConverter = (location: number) => {
  const sign = location >= 0 ? 1 : -1;
  location = Math.abs(location);

  const degree = Math.floor(location);
  const minuteDecimal = (location - degree) * 60;
  const minDegree = Math.floor(minuteDecimal);
  const secDegree = Number(((minuteDecimal - minDegree) * 60).toFixed(1));

  return {
    degree: degree * sign,
    minDegree,
    secDegree,
  };
};

export const convertMeasurement = (
  convertion: 'kgToLbs' | 'kgToG' | 'kgToMetricTon' | 'lbsToOz' | 'lbsToUsTon' | 'mToKm' | 'kphToKn',
  amount: number,
) => {
  let resultAmount: number = 0;
  switch (convertion) {
    case 'kgToLbs':
      resultAmount = amount * 2.20462262185;
      break;
    case 'kgToG':
      resultAmount = amount * 1000;
      break;
    case 'kgToMetricTon':
      resultAmount = amount / 1000;
      break;
    case 'lbsToOz':
      resultAmount = amount * 16;
      break;
    case 'lbsToUsTon':
      resultAmount = amount / 2000;
      break;
    case 'mToKm':
      resultAmount = amount / 1000;
      break;
    case 'kphToKn':
      resultAmount = amount / 1.85;
      break;
    default:
      break;
  }
  return resultAmount;
};

export const getProperWeightText = (type: EWeightUnit, amount: number) => {
  let weightText = '';
  if (type === EWeightUnit.Metric) {
    if (amount < 1) {
      weightText = `${convertMeasurement('kgToG', amount).toLocaleString()} G`;
    } else if (convertMeasurement('kgToMetricTon', amount) >= 1) {
      weightText = `${convertMeasurement('kgToMetricTon', amount).toLocaleString()} T`;
    } else {
      weightText = `${amount.toLocaleString()} KG`;
    }
  } else if (type === EWeightUnit.US) {
    if (amount < 1) {
      weightText = `${convertMeasurement('lbsToOz', amount).toLocaleString()} Oz`;
    } else if (convertMeasurement('lbsToUsTon', amount) >= 1) {
      weightText = `${convertMeasurement('lbsToUsTon', amount).toLocaleString()} T`;
    } else {
      weightText = `${amount.toLocaleString()} Lbs`;
    }
  }
  return weightText;
};
export const getProperDistanceText = (amount: number) => {
  let distanceText = '';
  if (convertMeasurement('mToKm', amount) >= 1) {
    distanceText = `${convertMeasurement('mToKm', amount).toLocaleString()} km`;
  } else {
    distanceText = `${amount.toLocaleString()} m`;
  }

  return distanceText;
};

export const radianToDegree = (radians: number) => {
  return radians * (180 / pi);
};

const normalizeHex = (hex: string) => {
  hex = hex.trim().replace(/^#/, '');

  if (hex.length === 3)
    hex = hex
      .split('')
      .map((c) => c + c)
      .join('');
  if (hex.length === 4)
    hex = hex
      .split('')
      .map((c) => c + c)
      .join('');
  if (hex.length === 6) hex += 'FF';

  return hex.toUpperCase();
};

// Hex'den rgba dönüşüm
const hexToRgba = (hex: string) => {
  const h = normalizeHex(hex);
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  const a = parseInt(h.slice(6, 8), 16) / 256;
  return { r, g, b, a };
};
// css rgb düzleminden lineer rgbye dönüşüm için gerekli.
const srgbToLinear = (c: number) => {
  const s = c / 255;
  return s <= 0.03928 ? s / 12.92 : ((s + 0.055) / 1.055) ** 2.4;
};

// Bagıl Lüminans ayarı. Bir renk düzlemi içinde relative luminance döndürür. wcag20 dökümanından alınmıştır.
const addLuminance = ({ r, g, b }: { r: number; g: number; b: number }) => {
  const RLocal = srgbToLinear(r);
  const GLocal = srgbToLinear(g);
  const BLocal = srgbToLinear(b);

  return 0.212 * RLocal + 0.7152 * GLocal + 0.0722 * BLocal;
};

// Yine wcag20'ye hesaplanmış degerlerin 7:1 degerinden büyük veya küçük olmasına baglı olarak hangi renk düzlemi ile uyumlu olabilecegi hesaplanmıştır.
export const properTextColor = (hex: string) => {
  const L = addLuminance(hexToRgba(hex));
  const contrastForBlack = (L + 0.05) / 0.05;
  const contrastForWhite = 1.05 / (L + 0.05);

  return contrastForBlack >= contrastForWhite ? '#000000' : '#FFFFFF';
};
